// @ts-strict-ignore

import { HighRangeOption, LowRangeOption } from 'flow/service/actions';
import type { OutputValueRange, ValueRangeConfigOptions } from 'flow/store/engine/types';

/**
 * Merges the two form data states, ensuring the after state does not overwrite previous state's
 * values with undefined. This is used to safeguard against react-hook-form's default behavior of returning
 * undefined for all disabled inputs.
 */
export function mergeFormData<T extends object>(prevState: T, afterState: T) {
  function merge<V extends object>(prev: V, after: V) {
    const merged: V = {} as V;
    for (const [key, afterValue] of Object.entries(after)) {
      switch (typeof afterValue) {
        case 'undefined': {
          merged[key] = prev[key];
          break;
        }
        case 'object': {
          if (afterValue === null || Array.isArray(afterValue)) {
            merged[key] = afterValue;
            break;
          }
          merged[key] = merge(prev[key], afterValue);
          break;
        }
        default: {
          merged[key] = afterValue;
        }
      }
    }
    return merged;
  }
  return merge(prevState, afterState);
}

export const getOutputValueRangeOptions = ({
  outputValueRangeOptions,
  outputValueRange,
}: {
  outputValueRangeOptions: ValueRangeConfigOptions;
  outputValueRange: OutputValueRange[];
}) => {
  if (outputValueRangeOptions) {
    return outputValueRangeOptions;
  }

  return {
    lowRange: outputValueRange?.[0]?.minValue !== null
      ? LowRangeOption.bounded
      : LowRangeOption.unbounded,
    highRange: outputValueRange?.[outputValueRange.length - 1]?.maxValue !== null
      ? HighRangeOption.bounded
      : HighRangeOption.unbounded,
  };
};
